/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast. Keeping your custom
* Javascript in this file will make it easier to update Broadcast.
*/


(function() {
  var CART_DRAWER_INNER_SELECTOR = 'cart-drawer .drawer__inner';
  var ANNOUNCEMENT_HOST_SELECTOR = '#yeps';
  var OFFSET_CLASS = 'drawer__inner--announcement-offset';

  var currentOffset = null;
  var rafId = null;
  var currentBar = null;
  var resizeObserver = window.ResizeObserver ? new ResizeObserver(scheduleUpdate) : null;
  var barAttributeObserver = new MutationObserver(scheduleUpdate);
  var observedBar = null;
  var intersectionObserver = window.IntersectionObserver
    ? new IntersectionObserver(handleIntersection, { threshold: [0, 0.25, 0.5, 0.75, 1] })
    : null;
  var hostObserver = null;
  var shadowObserver = null;

  function init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
      return;
    }

    scheduleUpdate();
    ensureHostObserver();

    window.addEventListener('load', scheduleUpdate);
    window.addEventListener('resize', scheduleUpdate);
    window.addEventListener('scroll', scheduleUpdate, { passive: true });
  }

  function scheduleUpdate() {
    if (rafId) {
      return;
    }

    rafId = window.requestAnimationFrame(function() {
      rafId = null;
      updateOffset();
    });
  }

  function updateOffset() {
    var bar = getAnnouncementBar();

    if (bar !== currentBar) {
      currentBar = bar;
      bindToBar(bar);
    }

    var offset = computeVisibleHeight(bar);
    applyOffset(offset);
  }

  function bindToBar(bar) {
    clearBarObservers();

    if (!bar) {
      unobserveBar();

      var host = document.querySelector(ANNOUNCEMENT_HOST_SELECTOR);

      if (host && host.shadowRoot) {
        ensureShadowObserver(host.shadowRoot);
      } else {
        ensureHostObserver();
      }

      return;
    }

    disconnectHostObserver();
    disconnectShadowObserver();

    if (resizeObserver) {
      resizeObserver.observe(bar);
    }

    barAttributeObserver.observe(bar, {
      attributes: true,
      attributeFilter: ['style', 'class']
    });

    observeBar(bar);
  }

  function clearBarObservers() {
    if (resizeObserver) {
      resizeObserver.disconnect();
    }

    barAttributeObserver.disconnect();
  }

  function observeBar(bar) {
    if (!intersectionObserver || !bar) {
      return;
    }

    if (observedBar && observedBar !== bar) {
      intersectionObserver.unobserve(observedBar);
    }

    intersectionObserver.observe(bar);
    observedBar = bar;
  }

  function unobserveBar() {
    if (!intersectionObserver || !observedBar) {
      return;
    }

    intersectionObserver.unobserve(observedBar);
    observedBar = null;
  }

  function handleIntersection(entries) {
    for (var i = 0; i < entries.length; i++) {
      if (entries[i].target === currentBar) {
        scheduleUpdate();
        break;
      }
    }
  }

  function ensureHostObserver() {
    if (document.querySelector(ANNOUNCEMENT_HOST_SELECTOR)) {
      disconnectHostObserver();
      return;
    }

    if (hostObserver) {
      return;
    }

    hostObserver = new MutationObserver(function() {
      if (document.querySelector(ANNOUNCEMENT_HOST_SELECTOR)) {
        disconnectHostObserver();
        scheduleUpdate();
      }
    });

    hostObserver.observe(document.body, { childList: true, subtree: true });
  }

  function disconnectHostObserver() {
    if (!hostObserver) {
      return;
    }

    hostObserver.disconnect();
    hostObserver = null;
  }

  function ensureShadowObserver(shadowRoot) {
    if (!shadowRoot || shadowObserver) {
      return;
    }

    shadowObserver = new MutationObserver(function() {
      if (getAnnouncementBar()) {
        disconnectShadowObserver();
        scheduleUpdate();
      }
    });

    shadowObserver.observe(shadowRoot, { childList: true, subtree: true });
  }

  function disconnectShadowObserver() {
    if (!shadowObserver) {
      return;
    }

    shadowObserver.disconnect();
    shadowObserver = null;
  }

  function getAnnouncementBar() {
    var host = document.querySelector(ANNOUNCEMENT_HOST_SELECTOR);

    if (!host) {
      return null;
    }

    var root = host.shadowRoot || host;

    return root.querySelector('.yeps-frame') || root.querySelector('.yeps-bar');
  }

  function computeVisibleHeight(bar) {
    if (!bar) {
      return 0;
    }

    var frame = bar.classList && bar.classList.contains('yeps-frame') ? bar : bar.closest('.yeps-frame');

    if (frame && !frame.classList.contains('yeps-top')) {
      return 0;
    }

    var rect = bar.getBoundingClientRect();
    var visible = Math.min(rect.height, Math.max(0, rect.bottom));

    return Math.round(visible);
  }

  function applyOffset(offset) {
    if (offset === currentOffset) {
      return;
    }

    currentOffset = offset;

    var innerElements = document.querySelectorAll(CART_DRAWER_INNER_SELECTOR);

    innerElements.forEach(function(inner) {
      if (offset > 0) {
        inner.style.marginTop = offset + 'px';
        inner.classList.add(OFFSET_CLASS);
      } else {
        inner.style.marginTop = '';
        inner.classList.remove(OFFSET_CLASS);
      }
    });
  }

  var KAI_POPUP_SELECTOR = '.bmsm-gift-popup';
  var KAI_OPTIONS_CONTAINER_SELECTOR = '.bmsm-gift-options';
  var KAI_VARIANT_SELECT_SELECTOR = '.bmsm-gift-variants';
  var KAI_SELECT_BUTTON_SELECTOR = '.bmsm-gift-select-btn';
  var KAI_CLOSE_BUTTON_SELECTOR = '.bmsm-gift-popup-close-btn';
  var KAI_GIFT_CARD_SELECTOR = '.bmsm-gift-card';

  function parseKaiOptionMap(raw) {
    if (!raw || typeof raw !== 'string') return {};

    var map = {};

    raw.split('\n').forEach(function(line) {
      var trimmed = line.trim();
      if (!trimmed) return;

      var parts = trimmed.split('=');
      if (!parts[0]) return;

      var key = parts[0].trim();
      var value = (parts[1] || '').trim();

      if (key) {
        map[key] = value || key;
      }
    });

    return map;
  }

  function applyKaiFreeGiftAdjustments(popup) {
    if (!popup || !window.theme || !window.theme.settings) return;

    var cfg = window.theme.settings.kaiFreeGift;

    if (!cfg || !cfg.enableAdjustments) {
      return;
    }
    var giftCard = popup.querySelector(KAI_GIFT_CARD_SELECTOR);
    if (!giftCard) {
      observeKaiPopupChanges(popup);
    }

    var select = popup.querySelector(KAI_VARIANT_SELECT_SELECTOR);
    if (select) {

      if (cfg.selectText) {
        var selectBtn = popup.querySelector(KAI_SELECT_BUTTON_SELECTOR);
        if (selectBtn) {
          selectBtn.textContent = cfg.selectText;
        }
      }

      if (cfg.option1Label) {
        var labelId = 'kai-free-gift-option-1-label';
        var existingLabel = popup.querySelector('#' + labelId);
  
        if (!existingLabel && select.parentNode) {
          existingLabel = document.createElement('div');
          existingLabel.id = labelId;
          existingLabel.className = 'bmsm-gift-option-label';
          select.parentNode.insertBefore(existingLabel, select);
        }
  
        if (existingLabel) {
          existingLabel.textContent = cfg.option1Label;
        }
      }
  
      var valueMap = parseKaiOptionMap(cfg.option1ValuesMap);
  
      Array.prototype.forEach.call(select.options, function(option) {
        var originalText = option.getAttribute('data-kai-original-text');
  
        if (!originalText) {
          originalText = (option.textContent || '').trim();
          option.setAttribute('data-kai-original-text', originalText);
        }
  
        var text = originalText;
        if (!text) return;
  
        var labelPart = text;
        var pricePart = '';
        var separatorIndex = text.indexOf(' - ');
  
        if (separatorIndex > -1) {
          labelPart = text.slice(0, separatorIndex);
          pricePart = text.slice(separatorIndex + 3);
        }
  
        var trimmedLabel = labelPart.trim();
        var mappedLabel = valueMap[trimmedLabel] || trimmedLabel;
        var newText = mappedLabel;
  
        if (!cfg.removePrice && pricePart) {
          newText += ' - ' + pricePart.trim();
        }
  
        option.textContent = newText;
      });
    };

    var closeBtn = popup.querySelector(KAI_CLOSE_BUTTON_SELECTOR);

    if (closeBtn) {
      var closeText = window.theme && window.theme.strings && window.theme.strings.close;
      if (closeText) {
        closeBtn.textContent = closeText;
      }

      if (cfg.autoAddOnClose && !closeBtn.hasAttribute('data-kai-auto-add-bound')) {
        closeBtn.setAttribute('data-kai-auto-add-bound', 'true');

        closeBtn.addEventListener('click', function() {
          var selectBtn = popup.querySelector(KAI_SELECT_BUTTON_SELECTOR);
          if (selectBtn) {
            selectBtn.click();
          }
        });
      }
    }

    if (select && popup._kaiPopupObserver) {
      popup._kaiPopupObserver.disconnect();
      popup._kaiPopupObserver = null;
    }
  }

  function observeKaiPopupChanges(popup) {
    if (!window.MutationObserver || !popup || popup._kaiPopupObserver) {
      return;
    }

    var optionsContainer = popup.querySelector(KAI_OPTIONS_CONTAINER_SELECTOR);
    if (!optionsContainer) {
      return;
    }

    var observer = new MutationObserver(function(mutations) {
      var shouldReapply = false;
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList' && mutation.addedNodes && mutation.addedNodes.length) {
          shouldReapply = true;
        }
      });

      if (shouldReapply) {
        applyKaiFreeGiftAdjustments(popup);
      }
    });

    observer.observe(optionsContainer, { childList: true, subtree: true });
    popup._kaiPopupObserver = observer;
  }

  function observeKaiFreeGiftPopup() {
    var runOnce = function() {
      var existing = document.querySelectorAll(KAI_POPUP_SELECTOR);
      if (existing && existing.length) {
        Array.prototype.forEach.call(existing, applyKaiFreeGiftAdjustments);
      }
    };

    if (document.body) {
      runOnce();
    } else {
      document.addEventListener('DOMContentLoaded', runOnce, { once: true });
    }
  }

  function initKaiFreeGift() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', observeKaiFreeGiftPopup, { once: true });
    } else {
      observeKaiFreeGiftPopup();
    }
  }

  init();
  initKaiFreeGift();
})();

/*
 * GARAN "Rechte bei der gesetzlichen Gewährleistung" app block on product pages.
 *
 * The app renders a plain native <details>. Hook it into the theme's
 * <collapsible-elements> so it opens and closes with the same height and fade
 * animation as the product accordion blocks. The matching styles live in
 * theme.css under "app block: GARAN".
 */
(function () {
  var DISCLOSURE_SELECTOR = '.eugl--notice-block details.eugl-notice__disclosure';

  function enhance(details) {
    if (details.hasAttribute('data-collapsible')) return;
    if (!window.customElements || !customElements.get('collapsible-elements')) return;

    var summary = details.querySelector('summary.eugl-notice__trigger');
    var body = details.querySelector('.eugl-notice__body');
    if (!summary || !body) return;

    // Mirror the theme accordion markup:
    // details[data-collapsible] > summary[data-collapsible-trigger] + body[data-collapsible-body] > [data-collapsible-content]
    var content = document.createElement('div');
    content.setAttribute('data-collapsible-content', '');
    while (body.firstChild) {
      content.appendChild(body.firstChild);
    }
    body.appendChild(content);

    summary.setAttribute('data-collapsible-trigger', '');
    body.setAttribute('data-collapsible-body', '');
    details.setAttribute('data-collapsible', '');

    if (details.hasAttribute('open')) {
      details.setAttribute('open', 'true');
      body.style.height = 'auto';
    }

    // CollapsibleElements collects its items in the constructor, so the wrapper
    // must already contain the details when it is upgraded. Build it inside an
    // inert <template> document and move it into the page in one step.
    var template = document.createElement('template');
    template.innerHTML = '<collapsible-elements single="true"></collapsible-elements>';
    var wrapper = template.content.firstElementChild;
    var parent = details.parentNode;
    var next = details.nextSibling;

    wrapper.appendChild(details);
    parent.insertBefore(wrapper, next);
  }

  function init() {
    document.querySelectorAll(DISCLOSURE_SELECTOR).forEach(enhance);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
